<template>
  <table :class="$style.table">
    <slot />
  </table>
</template>

<style lang="scss" module>
@use '@design' as *;

.table {
  margin: $size-grid-padding 0;

  th,
  td {
    padding: 0 $size-grid-padding * 0.5 $size-grid-padding * 0.5 0;

    &:last-child {
      padding-right: 0;
    }
  }

  tr:last-child {
    > th,
    > td {
      padding-bottom: 0;
    }
  }
}
</style>
